<template>
  <div id="nps-dashboard-page" class="p-6">
    <!-- Cabeçalho Limpo e Barra de Filtros com Badges de Período Integrados -->
    <div class="nps-header-section mb-6">
      <div class="flex flex-wrap items-center justify-between gap-4 mb-2" style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px;">
        <!-- Título e Subtítulo -->
        <div>
          <h1 class="text-2xl font-bold text-slate-800" style="font-size: 1.5rem; font-weight: 700; color: #0f172a; margin: 0;">Resultado Pesquisa NPS</h1>
          <p class="text-sm text-slate-500" style="font-size: 0.85rem; color: #64748b; margin: 2px 0 0 0;">Métricas e histórico de satisfação do cliente com base no WATI / WhatsApp Flows.</p>
        </div>

        <!-- Barra de Filtros Unificada (Pill Container) com Badges de 7d 30d 60d 90d + Datas + Busca -->
        <div class="nps-filter-pill-container shadow-sm" style="display: flex; align-items: center; gap: 8px; background: white; border: 1px solid #cbd5e1; border-radius: 10px; padding: 6px 12px; flex-wrap: wrap;">
          <!-- Badges de Período Rápido (7d, 30d, 60d, 90d) ao lado das datas -->
          <div class="nps-period-badges" style="display: inline-flex; align-items: center; gap: 2px; background: #f8fafc; padding: 2px 4px; border-radius: 6px; border: 1px solid #e2e8f0;">
            <button
              v-for="p in periodosDisponiveis"
              :key="'p-' + p.dias"
              type="button"
              class="nps-badge-btn"
              :class="{ active: filtro.periodoDias === p.dias }"
              @click="selecionarPeriodo(p.dias)"
            >
              {{ p.label }}
            </button>
          </div>

          <div style="width: 1px; height: 24px; background: #e2e8f0;"></div>

          <!-- Input De -->
          <div style="display: flex; align-items: center; gap: 4px;">
            <span style="font-size: 10px; font-weight: 700; color: #64748b; text-transform: uppercase;">DE:</span>
            <input type="date" v-model="filtro.dataDe" class="nps-header-input" @change="onFilterInputChange" style="border: none; outline: none; font-size: 12px; color: #0f172a; background: transparent;" />
          </div>

          <div style="width: 1px; height: 24px; background: #e2e8f0;"></div>

          <!-- Input Até -->
          <div style="display: flex; align-items: center; gap: 4px;">
            <span style="font-size: 10px; font-weight: 700; color: #64748b; text-transform: uppercase;">ATÉ:</span>
            <input type="date" v-model="filtro.dataAte" class="nps-header-input" @change="onFilterInputChange" style="border: none; outline: none; font-size: 12px; color: #0f172a; background: transparent;" />
          </div>

          <div style="width: 1px; height: 24px; background: #e2e8f0;"></div>

          <!-- Input Busca -->
          <div style="position: relative; display: flex; align-items: center; min-width: 180px;">
            <vs-icon icon="search" style="font-size: 16px; color: #94a3b8; margin-right: 4px;"></vs-icon>
            <input type="text" v-model="filtro.busca" placeholder="Buscar cliente..." class="nps-header-input" style="width: 100%; border: none; outline: none; background: transparent; font-size: 12px; color: #0f172a;" @input="onSearchInputDebounced" />
            <span v-if="filtro.busca" class="nps-clear-icon" @click="limparBusca" style="position: relative; right: 0;">×</span>
          </div>

          <!-- Botão Filtrar -->
          <vs-button color="#0284c7" type="filled" size="small" style="border-radius: 6px; font-weight: 600; padding: 4px 12px; height: 28px;" @click="carregarDados">
            Filtrar
          </vs-button>

          <!-- Botão Importar Respostas (CSV/WATI) -->
          <vs-button color="#475569" type="border" size="small" icon="cloud_upload" style="border-radius: 6px; font-weight: 600; padding: 4px 12px; height: 28px;" @click="modalImportarAtivo = true">
            Importar Respostas
          </vs-button>

          <!-- Botão Disparar Pesquisas (Modal de Envio em Massa) -->
          <vs-button color="#10b981" type="filled" size="small" icon="send" style="border-radius: 6px; font-weight: 600; padding: 4px 12px; height: 28px; background-color: #10b981;" @click="modalMassaAtivo = true">
            Disparar Pesquisas
          </vs-button>
        </div>
      </div>
    </div>

    <!-- Skeleton Loading State -->
    <div v-if="carregando" class="nps-skeleton-wrapper">
      <div class="vx-row mb-6" style="display: flex; gap: 16px; flex-wrap: wrap;">
        <div v-for="i in 4" :key="'sk-card-' + i" class="vx-col flex-1" style="flex: 1; min-width: 240px;">
          <div class="nps-card-skeleton p-4" style="background: white; border-radius: 12px; border: 1px solid #e2e8f0; height: 110px;">
            <div class="nps-skeleton-line w-1-2 mb-3" style="width: 50%; height: 14px; background: #e2e8f0; border-radius: 4px;"></div>
            <div class="nps-skeleton-line w-3-4 mb-3" style="width: 75%; height: 28px; background: #cbd5e1; border-radius: 6px;"></div>
            <div class="nps-skeleton-line w-full" style="width: 100%; height: 8px; background: #f1f5f9; border-radius: 999px;"></div>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6" style="display: flex; gap: 16px; flex-wrap: wrap;">
        <div v-for="i in 2" :key="'sk-chart-' + i" class="vx-col flex-1" style="flex: 1; min-width: 480px;">
          <div class="nps-card-skeleton p-4" style="background: white; border-radius: 12px; border: 1px solid #e2e8f0; height: 280px; display: flex; flex-direction: column; justify-content: space-between;">
            <div class="nps-skeleton-line w-1-3" style="width: 35%; height: 18px; background: #e2e8f0; border-radius: 4px;"></div>
            <div class="nps-skeleton-line w-full" style="width: 100%; height: 200px; background: #f8fafc; border-radius: 8px;"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Conteúdo Principal do Dashboard -->
    <div v-else class="nps-content-wrapper">
      <!-- Cards de Indicadores (Métricas NPS) - Grid Unificado de Altura Idêntica (150px) -->
      <div class="nps-cards-grid mb-6">
        <!-- Card 1: Score NPS -->
        <vx-card class="nps-card-metric relative overflow-hidden" card-background="#ffffff">
          <div class="flex justify-between items-start" style="display: flex; justify-content: space-between; align-items: flex-start;">
            <div>
              <p class="text-sm font-semibold" style="color: #64748b; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">SCORE NPS</p>
              <h2 class="text-3xl font-extrabold mt-1" :style="{ color: getNpsColor(stats.nps_score), fontSize: '2.25rem', fontWeight: '800', lineHeight: '1' }">
                {{ stats.nps_score }}
              </h2>
            </div>
            <div class="rounded-full p-2" :style="{ backgroundColor: getNpsBgColor(stats.nps_score) }" style="border-radius: 50%; padding: 8px; display: flex; align-items: center; justify-content: center;">
              <vs-icon icon="trending_up" style="font-size: 20px; color: white;"></vs-icon>
            </div>
          </div>
          <div style="margin-top: auto;">
            <div class="w-full bg-slate-100 rounded-full" style="background-color: #f1f5f9; border-radius: 9999px; height: 6px; overflow: hidden; margin-bottom: 4px;">
              <div class="h-full rounded-full" :style="{ width: getNpsProgressWidth(stats.nps_score) + '%', backgroundColor: getNpsColor(stats.nps_score) }" style="height: 100%;"></div>
            </div>
            <p class="text-xs text-slate-400" style="font-size: 11px; color: #94a3b8; margin: 0;">Zona: {{ getNpsZoneName(stats.nps_score) }}</p>
          </div>
        </vx-card>

        <!-- Card 2: Taxa de Resposta -->
        <vx-card class="nps-card-metric relative overflow-hidden" card-background="#ffffff">
          <div class="flex justify-between items-start" style="display: flex; justify-content: space-between; align-items: flex-start;">
            <div>
              <p class="text-sm font-semibold" style="color: #64748b; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">TAXA DE RESPOSTA</p>
              <h2 class="text-3xl font-extrabold mt-1 text-sky-600" style="font-size: 2.25rem; font-weight: 800; color: #0284c7; lineHeight: '1';">
                {{ stats.taxa_resposta }}%
              </h2>
            </div>
            <div class="rounded-full p-2 bg-sky-500" style="border-radius: 50%; padding: 8px; background-color: #0284c7; display: flex; align-items: center; justify-content: center;">
              <vs-icon icon="chat_bubble_outline" style="font-size: 20px; color: white;"></vs-icon>
            </div>
          </div>
          <div style="margin-top: auto; font-size: 11px; color: #475569; padding-top: 8px; border-top: 1px solid #f1f5f9; display: flex; justify-content: space-between;">
            <span>Enviados: <strong>{{ stats.total_enviados }}</strong></span>
            <span>Respondidos: <strong>{{ stats.total_respondidos }}</strong></span>
          </div>
        </vx-card>

        <!-- Card 3: Cobertura de OSs Executadas -->
        <vx-card class="nps-card-metric relative overflow-hidden" card-background="#ffffff">
          <div class="flex justify-between items-start" style="display: flex; justify-content: space-between; align-items: flex-start;">
            <div>
              <p class="text-sm font-semibold" style="color: #64748b; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">COBERTURA DE OSs</p>
              <h2 class="text-3xl font-extrabold mt-1 text-emerald-600" style="font-size: 2.25rem; font-weight: 800; color: #059669; line-height: 1;">
                {{ stats.taxa_cobertura || 0 }}%
              </h2>
            </div>
            <div class="rounded-full p-2 bg-emerald-500" style="border-radius: 50%; padding: 8px; background-color: #059669; display: flex; align-items: center; justify-content: center;">
              <vs-icon icon="assignment_turned_in" style="font-size: 20px; color: white;"></vs-icon>
            </div>
          </div>
          <div style="margin-top: auto;">
            <div class="w-full bg-slate-100 rounded-full" style="background-color: #f1f5f9; border-radius: 9999px; height: 6px; overflow: hidden; margin-bottom: 4px;">
              <div class="h-full rounded-full" :style="{ width: Math.min(stats.taxa_cobertura || 0, 100) + '%', backgroundColor: ((stats.taxa_cobertura || 0) >= 80 ? '#10b981' : ((stats.taxa_cobertura || 0) >= 50 ? '#0284c7' : '#f59e0b')) }" style="height: 100%;"></div>
            </div>
            <div style="font-size: 10px; color: #475569; display: flex; justify-content: space-between;">
              <span>Executadas: <strong>{{ stats.total_os_executadas || 0 }}</strong></span>
              <span>Disparadas: <strong>{{ stats.total_enviados || 0 }}</strong></span>
            </div>
          </div>
        </vx-card>

        <!-- Card 4: Indicação (Recomendação) -->
        <vx-card class="nps-card-metric relative overflow-hidden" card-background="#ffffff">
          <div class="flex justify-between items-start" style="display: flex; justify-content: space-between; align-items: flex-start;">
            <div>
              <p class="text-sm font-semibold" style="color: #64748b; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">INDICAÇÃO (RECOMENDAÇÃO)</p>
              <div class="flex items-center gap-4 mt-1" style="display: flex; gap: 16px; align-items: baseline;">
                <div @click="toggleFiltroIndicador('Sim')" style="cursor: pointer; padding: 2px 6px; border-radius: 6px; transition: background 0.2s;" :style="{ background: filtro.indicador === 'Sim' ? '#dcfce7' : 'transparent' }">
                  <span class="text-xs text-emerald-600 font-bold block" style="font-size: 10px; color: #059669; font-weight: 700;">Promotores</span>
                  <span class="text-xl font-extrabold" style="font-size: 1.5rem; font-weight: 800; color: #0f172a;">{{ stats.total_promotores }}</span>
                </div>
                <div style="width: 1px; height: 20px; background: #e2e8f0;"></div>
                <div @click="toggleFiltroIndicador('Não')" style="cursor: pointer; padding: 2px 6px; border-radius: 6px; transition: background 0.2s;" :style="{ background: filtro.indicador === 'Não' ? '#ffe4e6' : 'transparent' }">
                  <span class="text-xs text-rose-600 font-bold block" style="font-size: 10px; color: #e11d48; font-weight: 700;">Detratores</span>
                  <span class="text-xl font-extrabold" style="font-size: 1.5rem; font-weight: 800; color: #0f172a;">{{ stats.total_detratores }}</span>
                </div>
              </div>
            </div>
            <div class="rounded-full p-2 bg-emerald-500" style="border-radius: 50%; padding: 8px; background-color: #10b981; display: flex; align-items: center; justify-content: center;">
              <vs-icon icon="thumb_up_alt" style="font-size: 20px; color: white;"></vs-icon>
            </div>
          </div>
          <div style="margin-top: auto;">
            <div class="w-full bg-slate-100 rounded-full overflow-hidden flex" style="background-color: #f1f5f9; border-radius: 9999px; height: 6px; display: flex;">
              <div class="bg-emerald-500" :style="{ width: getIndicatorPercent('promotores') + '%' }" style="background-color: #10b981; height: 100%;"></div>
              <div class="bg-rose-500" :style="{ width: getIndicatorPercent('detratores') + '%' }" style="background-color: #f43f5e; height: 100%;"></div>
            </div>
          </div>
        </vx-card>

        <!-- Card 4: Nível de Satisfação Clicável -->
        <vx-card class="nps-card-metric relative overflow-hidden" card-background="#ffffff">
          <div class="flex justify-between items-start" style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 8px;">
            <p class="text-sm font-semibold" style="color: #64748b; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">NÍVEL DE SATISFAÇÃO</p>
            <div class="rounded-full p-2 bg-amber-500" style="border-radius: 50%; padding: 8px; background-color: #f59e0b; display: flex; align-items: center; justify-content: center;">
              <vs-icon icon="sentiment_satisfied_alt" style="font-size: 20px; color: white;"></vs-icon>
            </div>
          </div>
          <div style="margin-top: auto; display: grid; grid-template-columns: 1fr 1fr; gap: 6px; font-size: 11px;">
            <div
              @click="toggleFiltroSatisfacao('Excelente')"
              class="flex items-center gap-1 nps-clickable-pill"
              :class="{ active: filtro.satisfacao === 'Excelente' }"
              style="display: flex; align-items: center; background: #f8fafc; padding: 4px 6px; border-radius: 6px; cursor: pointer; transition: all 0.2s;"
            >
              <span>😄 Excelente:</span>
              <strong style="color: #10b981; margin-left: auto;">{{ stats.satisfacao.excelente }}</strong>
            </div>
            <div
              @click="toggleFiltroSatisfacao('Bom')"
              class="flex items-center gap-1 nps-clickable-pill"
              :class="{ active: filtro.satisfacao === 'Bom' }"
              style="display: flex; align-items: center; background: #f8fafc; padding: 4px 6px; border-radius: 6px; cursor: pointer; transition: all 0.2s;"
            >
              <span>🙂 Bom:</span>
              <strong style="color: #0284c7; margin-left: auto;">{{ stats.satisfacao.bom }}</strong>
            </div>
            <div
              @click="toggleFiltroSatisfacao('Ruim')"
              class="flex items-center gap-1 nps-clickable-pill"
              :class="{ active: filtro.satisfacao === 'Ruim' }"
              style="display: flex; align-items: center; background: #f8fafc; padding: 4px 6px; border-radius: 6px; cursor: pointer; transition: all 0.2s;"
            >
              <span>😕 Ruim:</span>
              <strong style="color: #f59e0b; margin-left: auto;">{{ stats.satisfacao.ruim }}</strong>
            </div>
            <div
              @click="toggleFiltroSatisfacao('Péssimo')"
              class="flex items-center gap-1 nps-clickable-pill"
              :class="{ active: filtro.satisfacao === 'Péssimo' }"
              style="display: flex; align-items: center; background: #f8fafc; padding: 4px 6px; border-radius: 6px; cursor: pointer; transition: all 0.2s;"
            >
              <span>😡 Péssimo:</span>
              <strong style="color: #ef4444; margin-left: auto;">{{ stats.satisfacao.pessimo }}</strong>
            </div>
          </div>
        </vx-card>
      </div>

      <!-- Seção de Gráficos de Área (Shadcn UI Area Charts) -->
      <div class="vx-row mb-6" style="display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 24px;">
        <!-- Gráfico de Área: Evolução do Score NPS -->
        <div class="vx-col flex-1" style="flex: 1; min-width: 480px;">
          <vx-card class="shadow-sm border border-slate-200" card-background="#ffffff" style="border-radius: 12px; border: 1px solid #e2e8f0; padding: 16px;">
            <div class="flex justify-between items-center mb-4" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
              <div>
                <h3 class="text-base font-bold text-slate-800" style="font-size: 1rem; font-weight: 700; color: #1e293b; margin-bottom: 2px;">Evolução do Score NPS</h3>
                <p class="text-xs text-slate-400" style="font-size: 11px; color: #94a3b8;">Tendência acumulada do Score no período selecionado.</p>
              </div>
              <vs-chip color="#00bba2" transparent style="font-weight: 600; font-size: 11px;">
                <vs-icon icon="show_chart" size="14px" class="mr-1"></vs-icon> Área Spline
              </vs-chip>
            </div>
            <vue-apex-charts
              type="area"
              height="240"
              :options="areaChartScoreOptions"
              :series="areaChartScoreSeries"
            ></vue-apex-charts>
          </vx-card>
        </div>

        <!-- Gráfico de Área: Promotores vs Detratores -->
        <div class="vx-col flex-1" style="flex: 1; min-width: 480px;">
          <vx-card class="shadow-sm border border-slate-200" card-background="#ffffff" style="border-radius: 12px; border: 1px solid #e2e8f0; padding: 16px;">
            <div class="flex justify-between items-center mb-4" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
              <div>
                <h3 class="text-base font-bold text-slate-800" style="font-size: 1rem; font-weight: 700; color: #1e293b; margin-bottom: 2px;">Promotores vs Detratores</h3>
                <p class="text-xs text-slate-400" style="font-size: 11px; color: #94a3b8;">Volume de clientes que recomendam vs não recomendam.</p>
              </div>
              <vs-chip color="#3b82f6" transparent style="font-weight: 600; font-size: 11px;">
                <vs-icon icon="pie_chart" size="14px" class="mr-1"></vs-icon> Área Comparativa
              </vs-chip>
            </div>
            <vue-apex-charts
              type="area"
              height="240"
              :options="areaChartVolumeOptions"
              :series="areaChartVolumeSeries"
            ></vue-apex-charts>
          </vx-card>
        </div>
      </div>
    </div>

    <!-- Tabela de Resultados -->
    <div class="bg-white rounded-lg shadow-sm border border-slate-200 mt-6" style="background-color: white; border-radius: 12px; border: 1px solid #e2e8f0; padding: 16px; min-height: 50vh;">
      <div class="flex justify-between items-center mb-4" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
        <h3 class="text-lg font-bold text-slate-800" style="font-size: 1.125rem; font-weight: 700; color: #1e293b;">Respostas Detalhadas</h3>
        <vs-select placeholder="Filtrar Status" v-model="filtro.status" size="small" style="min-width: 140px;" @change="carregarDados">
          <vs-select-item value="" text="Todos os Status" />
          <vs-select-item value="enviado" text="Enviado" />
          <vs-select-item value="respondido" text="Respondido" />
          <vs-select-item value="falha" text="Falha" />
        </vs-select>
      </div>

      <div class="vs-con-loading__container" id="nps-table-container">
        <vs-table max-items="10" pagination :data="resultados" stripe>
          <template slot="thead">
            <vs-th style="width: 12%">OS / Execução</vs-th>
            <vs-th style="width: 22%">Cliente & Contrato</vs-th>
            <vs-th style="width: 12%">Telefone</vs-th>
            <vs-th style="width: 14%">Serviço & Técnico</vs-th>
            <vs-th style="width: 10%" id="center">Indicação</vs-th>
            <vs-th style="width: 10%" id="center">Satisfação</vs-th>
            <vs-th style="width: 12%">Comentário</vs-th>
            <vs-th style="width: 8%" id="center">Ações</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" v-for="(tr, index) in data">
              <!-- OS / Data Execução -->
              <vs-td :data="tr.id_os" style="font-size: 12px;">
                <div v-if="tr.id_os">
                  <span class="font-bold" style="color: #0f172a;">OS #{{ tr.id_os }}</span>
                  <div v-if="tr.os_data_execucao" style="font-size: 10px; color: #64748b;">
                    Exec: {{ tr.os_data_execucao }}
                  </div>
                  <div v-if="tr.os_pos_venda === 1" style="font-size: 10px; color: #059669; font-weight: 600;">
                    ✓ Concluído
                  </div>
                  <div v-else-if="tr.os_pos_venda === 2" style="font-size: 10px; color: #d97706; font-weight: 600;">
                    ⏱ Remarcado
                  </div>
                  <div v-else style="font-size: 10px; color: #64748b;">
                    Pós-Venda Pendente
                  </div>
                </div>
                <span v-else style="color: #94a3b8;">--</span>
              </vs-td>

              <!-- Cliente & Contrato -->
              <vs-td :data="tr.nomeCliente" class="font-semibold" style="font-size: 12px; color: #1e293b;">
                <a v-if="tr.id_contrato > 0" :href="'contrato?id=' + tr.id_contrato" style="color: darkblue; cursor: pointer; font-weight: 600;">
                  {{ tr.nomeCliente }}
                </a>
                <span v-else>{{ tr.nomeCliente }}</span>
                <div v-if="tr.id_contrato > 0" style="font-size: 10px; color: #64748b; font-weight: normal;">
                  Contrato #{{ tr.id_contrato }}
                </div>
              </vs-td>

              <vs-td :data="tr.telefone" style="font-size: 12px;">
                {{ tr.telefone }}
              </vs-td>

              <!-- Serviço & Técnico -->
              <vs-td style="font-size: 12px;">
                <div style="font-weight: 600; color: #334155;">{{ tr.servico_nome || (tr.service_number + 'ª OS') }}</div>
                <div v-if="tr.tecnico_nome" style="font-size: 11px; color: #64748b;">Téc: {{ tr.tecnico_nome }}</div>
              </vs-td>

              <!-- Indicação -->
              <vs-td :data="tr.nps_indicador" class="text-center">
                <div v-if="tr.nps_indicador === 'Sim'">
                  <Badge color="success" text="Recomenda"></Badge>
                </div>
                <div v-else-if="tr.nps_indicador === 'Não'">
                  <Badge color="danger" text="Não Recomenda"></Badge>
                </div>
                <span v-else style="color: #94a3b8;">--</span>
              </vs-td>

              <!-- Nível de Satisfação -->
              <vs-td :data="tr.nps_satisfacao" class="text-center">
                <div v-if="tr.nps_satisfacao === 'Excelente'">
                  <span style="font-size: 12px; font-weight: 600; color: #10b981;">😄 Excelente</span>
                </div>
                <div v-else-if="tr.nps_satisfacao === 'Bom'">
                  <span style="font-size: 12px; font-weight: 600; color: #0284c7;">🙂 Bom</span>
                </div>
                <div v-else-if="tr.nps_satisfacao === 'Ruim'">
                  <span style="font-size: 12px; font-weight: 600; color: #f59e0b;">😕 Ruim</span>
                </div>
                <div v-else-if="tr.nps_satisfacao === 'Péssimo'">
                  <span style="font-size: 12px; font-weight: 600; color: #ef4444;">😡 Péssimo</span>
                </div>
                <span v-else style="color: #94a3b8;">--</span>
              </vs-td>

              <!-- Comentário -->
              <vs-td :data="tr.comentario" style="font-size: 12px; color: #334155; font-style: italic;">
                {{ tr.comentario || "--" }}
              </vs-td>

              <!-- Ações (Reenviar se falha ou pendente) -->
              <vs-td class="text-center" style="font-size: 12px;">
                <div v-if="tr.status === 'respondido'">
                  <span style="font-size: 11px; color: #059669; font-weight: 600;">✓ Respondido</span>
                  <div style="font-size: 10px; color: #64748b;">{{ formatDataBR(tr.respondido_em) }}</div>
                </div>
                <div v-else style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                  <span v-if="tr.status === 'falha'" style="font-size: 10px; color: #ef4444; font-weight: 600;">Falha no envio</span>
                  <span v-else style="font-size: 10px; color: #0284c7; font-weight: 500;">Enviado em {{ formatDataBR(tr.created_at) }}</span>
                  <button
                    v-if="tr.id_os"
                    type="button"
                    class="nps-reemitir-btn"
                    @click="reenviarNpsUnitario(tr)"
                    style="font-size: 10px; font-weight: 600; color: #0284c7; background: #e0f2fe; border: 1px solid #bae6fd; border-radius: 4px; padding: 2px 6px; cursor: pointer;"
                    title="Reenviar pesquisa NPS via WhatsApp"
                  >
                    Reenviar
                  </button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

    <!-- Modal de Disparo em Massa NPS -->
    <modal-disparo-em-massa-nps
      :active.sync="modalMassaAtivo"
      @concluido="carregarDados"
    />

    <!-- Modal de Importação de Respostas NPS -->
    <modal-importar-nps
      :active.sync="modalImportarAtivo"
      @concluido="carregarDados"
    />
  </div>
</template>

<script>
import Badge from "@/components/default/Badge.vue";
import VueApexCharts from "vue-apexcharts";
import ModalDisparoEmMassaNps from "./components/modalDisparoEmMassaNps.vue";
import ModalImportarNps from "./components/modalImportarNps.vue";

export default {
  name: "ResultadoNps",
  components: {
    Badge,
    VueApexCharts,
    ModalDisparoEmMassaNps,
    ModalImportarNps
  },
  data() {
    return {
      modalMassaAtivo: false,
      modalImportarAtivo: false,
      periodosDisponiveis: [
        { dias: 7, label: "Semana" },
        { dias: 30, label: "Mês" },
        { dias: 60, label: "60 dias" },
        { dias: 90, label: "90 dias" }
      ],
      filtro: {
        dataDe: "",
        dataAte: "",
        busca: "",
        status: "",
        periodoDias: 30
      },
      searchTimeout: null,
      cancelTokenSource: null,
      carregando: false,
      stats: {
        total_enviados: 0,
        total_respondidos: 0,
        total_promotores: 0,
        total_detratores: 0,
        total_os_executadas: 0,
        taxa_cobertura: 0,
        nps_score: 0,
        taxa_resposta: 0,
        satisfacao: {
          excelente: 0,
          bom: 0,
          ruim: 0,
          pessimo: 0
        }
      },
      resultados: [],
      areaChartScoreOptions: {
        chart: {
          id: "nps-score-trend",
          type: "area",
          toolbar: { show: false },
          sparkline: { enabled: false },
          fontFamily: "'Inter', sans-serif"
        },
        colors: ["#00bba2"],
        dataLabels: { enabled: false },
        stroke: { curve: "smooth", width: 3 },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [0, 90, 100]
          }
        },
        xaxis: {
          categories: ["Semana 1", "Semana 2", "Semana 3", "Semana 4", "Hoje"],
          labels: { style: { colors: "#64748b", fontSize: "11px" } }
        },
        yaxis: {
          min: -100,
          max: 100,
          labels: { style: { colors: "#64748b", fontSize: "11px" } }
        },
        tooltip: { theme: "light" },
        grid: { borderColor: "#f1f5f9", strokeDashArray: 4 }
      },
      areaChartScoreSeries: [
        {
          name: "Score NPS",
          data: [0, 0, 0, 0, 0]
        }
      ],
      areaChartVolumeOptions: {
        chart: {
          id: "nps-volume-trend",
          type: "area",
          toolbar: { show: false },
          fontFamily: "'Inter', sans-serif"
        },
        colors: ["#10b981", "#ef4444"],
        dataLabels: { enabled: false },
        stroke: { curve: "smooth", width: 2 },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.35,
            opacityTo: 0.05,
            stops: [0, 90, 100]
          }
        },
        xaxis: {
          categories: ["Semana 1", "Semana 2", "Semana 3", "Semana 4", "Hoje"],
          labels: { style: { colors: "#64748b", fontSize: "11px" } }
        },
        yaxis: {
          labels: { style: { colors: "#64748b", fontSize: "11px" } }
        },
        tooltip: { theme: "light" },
        grid: { borderColor: "#f1f5f9", strokeDashArray: 4 }
      },
      areaChartVolumeSeries: [
        {
          name: "Promotores (Recomenda)",
          data: [0, 0, 0, 0, 0]
        },
        {
          name: "Detratores (Não Recomenda)",
          data: [0, 0, 0, 0, 0]
        }
      ]
    };
  },
  async mounted() {
    this.carregarFiltrosDaUrl();
    if (!this.filtro.dataDe || !this.filtro.dataAte) {
      this.selecionarPeriodo(30, false);
    }
    await this.carregarDados();
  },
  methods: {
    carregarFiltrosDaUrl() {
      const q = this.$route.query;
      if (q.dataDe) this.filtro.dataDe = q.dataDe;
      if (q.dataAte) this.filtro.dataAte = q.dataAte;
      if (q.busca) this.filtro.busca = q.busca;
      if (q.status) this.filtro.status = q.status;
      if (q.periodo) this.filtro.periodoDias = Number(q.periodo);
    },
    sincronizarFiltrosComUrl() {
      const query = {};
      if (this.filtro.dataDe) query.dataDe = this.filtro.dataDe;
      if (this.filtro.dataAte) query.dataAte = this.filtro.dataAte;
      if (this.filtro.busca) query.busca = this.filtro.busca;
      if (this.filtro.status) query.status = this.filtro.status;
      if (this.filtro.periodoDias) query.periodo = this.filtro.periodoDias;

      this.$router.push({ query }).catch(() => {});
    },
    selecionarPeriodo(dias, carregar = true) {
      this.filtro.periodoDias = dias;
      const ate = new Date();
      const de = new Date();
      de.setDate(ate.getDate() - dias);

      this.filtro.dataDe = this.formatDataISO(de);
      this.filtro.dataAte = this.formatDataISO(ate);

      this.sincronizarFiltrosComUrl();
      if (carregar) {
        this.carregarDados();
      }
    },
    onFilterInputChange() {
      this.filtro.periodoDias = null;
      this.sincronizarFiltrosComUrl();
      this.carregarDados();
    },
    onSearchInputDebounced() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.sincronizarFiltrosComUrl();
        this.carregarDados();
      }, 350);
    },
    limparBusca() {
      this.filtro.busca = "";
      this.onSearchInputDebounced();
    },
    async carregarDados() {
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel("Operação cancelada para novo filtro");
      }
      
      const axios = this.$http.axios || window.axios;
      if (axios && axios.CancelToken) {
        this.cancelTokenSource = axios.CancelToken.source();
      }

      await this.$vs.loading({ container: "#nps-table-container", scale: 0.6 });
      try {
        const queryParams = this.getQueryParams();
        const config = this.cancelTokenSource ? { cancelToken: this.cancelTokenSource.token } : {};

        // 1. Carregar estatísticas
        const resStats = await this.$http.get(`nps/stats${queryParams}`, config);
        if (resStats && resStats.success) {
          this.stats = resStats.stats;
        }

        // 2. Carregar listagem
        const resList = await this.$http.get(`nps/resultados${queryParams}`, config);
        if (resList && resList.success) {
          this.resultados = resList.resultados;
          this.atualizarGraficos();
        }
      } catch (err) {
        if (this.$http.isCancel && this.$http.isCancel(err)) {
          return;
        }
        console.error(err);
      } finally {
        await this.$vs.loading.close("#nps-table-container > .con-vs-loading");
      }
    },
    atualizarGraficos() {
      const respondidos = (this.resultados || []).filter(r => r.status === 'respondido');
      if (respondidos.length === 0) {
        this.areaChartScoreSeries = [{ name: "Score NPS", data: [0, 0, 0, 0, 0] }];
        this.areaChartVolumeSeries = [
          { name: "Promotores (Recomenda)", data: [0, 0, 0, 0, 0] },
          { name: "Detratores (Não Recomenda)", data: [0, 0, 0, 0, 0] }
        ];
        return;
      }

      const sorted = [...respondidos].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      const chunkSize = Math.max(1, Math.ceil(sorted.length / 5));
      const scoreData = [];
      const promotoresData = [];
      const detratoresData = [];

      for (let i = 0; i < 5; i++) {
        const slice = sorted.slice(0, (i + 1) * chunkSize);
        if (slice.length === 0) {
          scoreData.push(0);
          promotoresData.push(0);
          detratoresData.push(0);
          continue;
        }
        const prom = slice.filter(s => s.nps_indicador === 'Sim').length;
        const detr = slice.filter(s => s.nps_indicador === 'Não').length;
        const total = slice.length;
        const score = total > 0 ? Math.round(((prom - detr) / total) * 100) : 0;

        scoreData.push(score);
        promotoresData.push(prom);
        detratoresData.push(detr);
      }

      this.areaChartScoreSeries = [{ name: "Score NPS", data: scoreData }];
      this.areaChartVolumeSeries = [
        { name: "Promotores (Recomenda)", data: promotoresData },
        { name: "Detratores (Não Recomenda)", data: detratoresData }
      ];
    },
    async dispararPesquisasManual() {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Disparar Pesquisas NPS",
        text: "Deseja verificar os contratos elegíveis na metade da vigência e disparar as mensagens via WhatsApp?",
        acceptText: "Sim, disparar agora",
        cancelText: "Cancelar",
        accept: async () => {
          this.$vs.loading();
          try {
            const res = await this.$http.post("nps/disparar");
            if (res && res.success) {
              this.$vs.notify({
                title: "Disparos Realizados",
                text: res.message || "Pesquisas disparadas com sucesso!",
                color: "success",
                icon: "check"
              });
              await this.carregarDados();
            } else {
              this.$vs.notify({
                title: "Aviso",
                text: (res && res.message) || "Nenhum contrato elegível para disparo hoje.",
                color: "warning",
                icon: "warning"
              });
            }
          } catch (err) {
            this.$vs.notify({
              title: "Erro no Disparo",
              text: (err && err.response && err.response.data && err.response.data.message) || "Erro ao acionar disparos NPS.",
              color: "danger",
              icon: "error"
            });
          } finally {
            this.$vs.loading.close();
          }
        }
      });
    },
    getQueryParams() {
      const parts = [];
      if (this.filtro.dataDe) parts.push(`dataDe=${this.filtro.dataDe}`);
      if (this.filtro.dataAte) parts.push(`dataAte=${this.filtro.dataAte}`);
      if (this.filtro.busca) parts.push(`busca=${encodeURIComponent(this.filtro.busca)}`);
      if (this.filtro.status) parts.push(`status=${this.filtro.status}`);
      return parts.length > 0 ? "?" + parts.join("&") : "";
    },
    getNpsColor(score) {
      if (score >= 75) return "#10b981"; // Promotor / Excelência (Verde)
      if (score >= 50) return "#3b82f6"; // Qualidade / Bom (Azul)
      if (score >= 0) return "#f59e0b"; // Aperfeiçoamento (Amarelo)
      return "#ef4444"; // Crítico (Vermelho)
    },
    getNpsBgColor(score) {
      if (score >= 75) return "#059669";
      if (score >= 50) return "#2563eb";
      if (score >= 0) return "#d97706";
      return "#dc2626";
    },
    getNpsZoneName(score) {
      if (score >= 75) return "Excelência (75 a 100)";
      if (score >= 50) return "Qualidade (50 a 74)";
      if (score >= 0) return "Aperfeiçoamento (0 a 49)";
      return "Crítica (-100 a -1)";
    },
    getNpsProgressWidth(score) {
      // Normaliza score de [-100, 100] para [0, 100]
      return Math.round(((score + 100) / 200) * 100);
    },
    getIndicatorPercent(type) {
      const total = Number(this.stats.total_respondidos || 0);
      if (total === 0) return 0;
      if (type === 'promotores') {
        return Math.round((Number(this.stats.total_promotores) / total) * 100);
      }
      if (type === 'detratores') {
        return Math.round((Number(this.stats.total_detratores) / total) * 100);
      }
      return 0;
    },
    formatDataISO(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    formatDataBR(rawDate) {
      if (!rawDate) return "--";
      // Trata data ISO ou MySQL datetime
      try {
        const parts = rawDate.split("T");
        const dateParts = parts[0].split("-");
        if (dateParts.length === 3) {
          return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
        }
      } catch (e) {}
      return rawDate;
    },
    async reenviarNpsUnitario(item) {
      if (!item || !item.id_os) return;
      this.$vs.loading({ container: "#nps-table-container", scale: 0.6 });
      try {
        const res = await this.$http.post("nps/disparar-unitario", {
          id_os: item.id_os,
          telefone: item.telefone
        });
        if (res && res.data && res.data.success) {
          this.$vs.notify({
            color: "success",
            title: "NPS Reenviado!",
            text: res.data.message || "Pesquisa reenviada com sucesso."
          });
          this.carregarDados();
        } else {
          var msg = (res && res.data && res.data.message) ? res.data.message : "Falha ao reenviar pesquisa.";
          this.$vs.notify({
            color: "danger",
            title: "Erro ao Reenviar",
            text: msg
          });
        }
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close("#nps-table-container > .con-vs-loading");
      }
    }
  }
};
</script>

<style scoped>
.nps-badge-btn {
  background: transparent;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
}
.nps-badge-btn:hover {
  color: #0f172a;
  background: #f1f5f9;
}
.nps-badge-btn.active {
  background: #0f172a;
  color: white;
  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.15);
}

.nps-styled-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 12px;
  color: #0f172a;
  background-color: #ffffff;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.nps-styled-input:focus {
  border-color: #0284c7;
  box-shadow: 0 0 0 3px rgba(2, 132, 199, 0.15);
}

.nps-clear-icon {
  position: absolute;
  right: 10px;
  font-size: 16px;
  color: #94a3b8;
  cursor: pointer;
}

.nps-cards-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}
@media (max-width: 1400px) {
  .nps-cards-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 900px) {
  .nps-cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 640px) {
  .nps-cards-grid {
    grid-template-columns: 1fr;
  }
}

.nps-card-metric {
  height: 145px !important;
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 4px 12px -2px rgba(0, 0, 0, 0.04) !important;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.nps-card-metric ::v-deep .vx-card__body {
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  padding: 16px !important;
}

.nps-card-metric:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.01) !important;
}

@keyframes npsSkeletonPulse {
  0% { opacity: 0.5; }
  50% { opacity: 0.9; }
  100% { opacity: 0.5; }
}

.nps-skeleton-line {
  animation: npsSkeletonPulse 1.5s infinite ease-in-out;
}
</style>
